// @mui
import { AppBar, Stack, Toolbar, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Image from '../../components/image';
import { HEADER } from '../../config-global';

// ----------------------------------------------------------------------
export default function LoginHeader() {
  const theme = useTheme();
  const { pathname } = useLocation();
  const isProfessionalRoute =
    pathname.includes('professional-login') ||
    pathname.includes('professional-register');
  const logoHref = isProfessionalRoute
    ? '/auth/professional-login'
    : '/auth/login';
  const renderContent = (
    <>
      <Stack
        justifyContent="center"
        alignItems="center"
        component="a"
        href={logoHref}
        sx={{ textDecoration: 'none', cursor: 'pointer' }}
      >
        <Image
          disabledEffect
          visibleByDefault
          alt={isProfessionalRoute ? 'Vetsi Clinic Logo' : 'Vetsi Logo'}
          src={
            isProfessionalRoute
              ? '/assets/logo/vetsi-clinic-logo.svg'
              : '/assets/logo/logo_dashboard.svg'
          }
        />
      </Stack>
    </>
  );

  return (
    <>
      <AppBar
        sx={{
          boxShadow: theme.customShadows.z8,
          height: { xs: HEADER.H_MOBILE, lg: HEADER.H_MAIN_DESKTOP },
          zIndex: theme.zIndex.appBar + 1,
          backgroundColor: theme.palette.background.default,
          position: 'fixed',
        }}
      >
        <Toolbar
          sx={{
            height: 1,
            minHeight: { sm: HEADER.H_MOBILE, md: HEADER.H_MOBILE, lg: 1 },
            px: { sm: 2, lg: 5 },
          }}
        >
          {renderContent}
        </Toolbar>
      </AppBar>
    </>
  );
}
